import { BookingDragAndDropData } from "./booking_drag_and_drop_manager.types";

export const DRAG_THRESHOLD_PX = 4;
export const DRAG_HOLD_DELAY_MS = 500;

export const INITIAL_BOOKING_DRAG_AND_DROP_DATA: BookingDragAndDropData = {
  draggingMode: null,
  bookingId: null,
  draggingStartDate: null,
  draggingEndDate: null,
  isDraggingExiting: false,
  isBookingUpdating: false,
  sourceRow: null,
  dropZoneProfileRow: null,
  targetRow: null
};
